import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../wayfinder'
/**
* @see \App\Http\Controllers\ProfileManagementController::edit
* @see Http/Controllers/ProfileManagementController.php:23
* @route '//localhost/profile/{profile}/edit'
*/
export const edit = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '//localhost/profile/{profile}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProfileManagementController::edit
* @see Http/Controllers/ProfileManagementController.php:23
* @route '//localhost/profile/{profile}/edit'
*/
edit.url = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { profile: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { profile: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            profile: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        profile: typeof args.profile === 'object'
        ? args.profile.id
        : args.profile,
    }

    return edit.definition.url
            .replace('{profile}', parsedArgs.profile.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProfileManagementController::edit
* @see Http/Controllers/ProfileManagementController.php:23
* @route '//localhost/profile/{profile}/edit'
*/
edit.get = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProfileManagementController::edit
* @see Http/Controllers/ProfileManagementController.php:23
* @route '//localhost/profile/{profile}/edit'
*/
edit.head = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProfileManagementController::edit
* @see Http/Controllers/ProfileManagementController.php:23
* @route '//localhost/profile/{profile}/edit'
*/
const editForm = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProfileManagementController::edit
* @see Http/Controllers/ProfileManagementController.php:23
* @route '//localhost/profile/{profile}/edit'
*/
editForm.get = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProfileManagementController::edit
* @see Http/Controllers/ProfileManagementController.php:23
* @route '//localhost/profile/{profile}/edit'
*/
editForm.head = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\ProfileManagementController::update
* @see Http/Controllers/ProfileManagementController.php:66
* @route '//localhost/profile/{profile}'
*/
export const update = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '//localhost/profile/{profile}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ProfileManagementController::update
* @see Http/Controllers/ProfileManagementController.php:66
* @route '//localhost/profile/{profile}'
*/
update.url = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { profile: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { profile: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            profile: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        profile: typeof args.profile === 'object'
        ? args.profile.id
        : args.profile,
    }

    return update.definition.url
            .replace('{profile}', parsedArgs.profile.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProfileManagementController::update
* @see Http/Controllers/ProfileManagementController.php:66
* @route '//localhost/profile/{profile}'
*/
update.put = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\ProfileManagementController::update
* @see Http/Controllers/ProfileManagementController.php:66
* @route '//localhost/profile/{profile}'
*/
const updateForm = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProfileManagementController::update
* @see Http/Controllers/ProfileManagementController.php:66
* @route '//localhost/profile/{profile}'
*/
updateForm.put = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\ProfileManagementController::destroy
* @see Http/Controllers/ProfileManagementController.php:98
* @route '//localhost/profile/{profile}'
*/
export const destroy = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//localhost/profile/{profile}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\ProfileManagementController::destroy
* @see Http/Controllers/ProfileManagementController.php:98
* @route '//localhost/profile/{profile}'
*/
destroy.url = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { profile: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { profile: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            profile: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        profile: typeof args.profile === 'object'
        ? args.profile.id
        : args.profile,
    }

    return destroy.definition.url
            .replace('{profile}', parsedArgs.profile.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProfileManagementController::destroy
* @see Http/Controllers/ProfileManagementController.php:98
* @route '//localhost/profile/{profile}'
*/
destroy.delete = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\ProfileManagementController::destroy
* @see Http/Controllers/ProfileManagementController.php:98
* @route '//localhost/profile/{profile}'
*/
const destroyForm = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProfileManagementController::destroy
* @see Http/Controllers/ProfileManagementController.php:98
* @route '//localhost/profile/{profile}'
*/
destroyForm.delete = (args: { profile: string | number | { id: string | number } } | [profile: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

/**
* @see \App\Http\Controllers\ProfileCreationController::create
* @see Http/Controllers/ProfileCreationController.php:21
* @route '//localhost/profile/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '//localhost/profile/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\ProfileCreationController::create
* @see Http/Controllers/ProfileCreationController.php:21
* @route '//localhost/profile/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProfileCreationController::create
* @see Http/Controllers/ProfileCreationController.php:21
* @route '//localhost/profile/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProfileCreationController::create
* @see Http/Controllers/ProfileCreationController.php:21
* @route '//localhost/profile/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\ProfileCreationController::create
* @see Http/Controllers/ProfileCreationController.php:21
* @route '//localhost/profile/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProfileCreationController::create
* @see Http/Controllers/ProfileCreationController.php:21
* @route '//localhost/profile/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\ProfileCreationController::create
* @see Http/Controllers/ProfileCreationController.php:21
* @route '//localhost/profile/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\ProfileCreationController::store
* @see Http/Controllers/ProfileCreationController.php:33
* @route '//localhost/profile'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '//localhost/profile',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ProfileCreationController::store
* @see Http/Controllers/ProfileCreationController.php:33
* @route '//localhost/profile'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\ProfileCreationController::store
* @see Http/Controllers/ProfileCreationController.php:33
* @route '//localhost/profile'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProfileCreationController::store
* @see Http/Controllers/ProfileCreationController.php:33
* @route '//localhost/profile'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\ProfileCreationController::store
* @see Http/Controllers/ProfileCreationController.php:33
* @route '//localhost/profile'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

const myProfile = {
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
}

export default myProfile